<template>
    <v-app>
        <v-navigation-drawer
            v-model="drawer"
            app
            left
        >
            <v-list dense>
                <template v-if="type === 'tutor'">
                    <v-list-group no-action>
                        <template v-slot:activator>
                            <v-list-item-action>
                                <v-icon>mdi-account</v-icon>
                            </v-list-item-action>
                            <v-list-item-title v-text="fullName"></v-list-item-title>
                        </template>
                        <v-list-item :to="`/${$i18n.locale}/tutor/profile`">
                            <v-list-item-action>
                                <v-icon>mdi-account-box</v-icon>
                            </v-list-item-action>
                            <v-list-item-title v-text="$t('Profile')"></v-list-item-title>
                        </v-list-item>
                        <template v-if="user.customerId && user.completedProfile && user.active">
                            <v-list-item :to="`/${$i18n.locale}/tutor/resources`">
                                <v-list-item-action>
                                    <v-icon>mdi-book-open-page-variant</v-icon>
                                </v-list-item-action>
                                <v-list-item-title v-text="$t('Resources')"></v-list-item-title>
                            </v-list-item>
                            <v-list-item :to="`/${$i18n.locale}/tutor/calendar`">
                                <v-list-item-action>
                                    <v-icon>mdi-calendar</v-icon>
                                </v-list-item-action>
                                <v-list-item-title v-text="$t('Calendar')"></v-list-item-title>
                            </v-list-item>
                            <v-list-item :to="`/${$i18n.locale}/tutor/sessions`">
                                <v-list-item-action>
                                    <v-icon>mdi-calendar-text</v-icon>
                                </v-list-item-action>
                                <v-list-item-title v-text="$t('Sessions')"></v-list-item-title>
                            </v-list-item>
                            <v-list-item :to="`/${$i18n.locale}/tutor/settings`">
                                <v-list-item-action>
                                    <v-icon>mdi-cog</v-icon>
                                </v-list-item-action>
                                <v-list-item-title v-text="$t('Settings')"></v-list-item-title>
                            </v-list-item>
                            <v-list-item :to="`/${$i18n.locale}/tutor/billing`">
                                <v-list-item-action>
                                    <v-icon>mdi-credit-card</v-icon>
                                </v-list-item-action>
                                <v-list-item-title v-text="$t('Billing')"></v-list-item-title>
                            </v-list-item>                        
                        </template>
                    </v-list-group>
                </template>
                <template v-else-if="type === 'student' || type === 'parent'">
                    <v-list-group no-action>
                        <template v-slot:activator>
                            <v-list-item-action>
                                <v-icon>mdi-account</v-icon>
                            </v-list-item-action>
                            <v-list-item-title v-text="fullName"></v-list-item-title>
                        </template>
                        <v-list-item :to="`/${$i18n.locale}/student/profile`">
                            <v-list-item-action>
                                <v-icon>mdi-account-box</v-icon>
                            </v-list-item-action>
                            <v-list-item-title v-text="$t('Profile')"></v-list-item-title>
                        </v-list-item>
                        <v-list-item :to="`/${$i18n.locale}/student/sessions`">
                            <v-list-item-action>
                                <v-icon>mdi-calendar-text</v-icon>
                            </v-list-item-action>
                            <v-list-item-title v-text="$t('Sessions')"></v-list-item-title>
                        </v-list-item>
                        <v-list-item :to="`/${$i18n.locale}/student/settings`">
                            <v-list-item-action>
                                <v-icon>mdi-cog</v-icon>
                            </v-list-item-action>
                            <v-list-item-title v-text="$t('Settings')"></v-list-item-title>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item :to="`/${$i18n.locale}/student/askMentor`">
                        <v-list-item-title v-text="$t('ASK A MENTOR')"></v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="`/${$i18n.locale}/student/tutors`">
                        <v-list-item-action>
                            <v-icon>mdi-account-tie</v-icon>
                        </v-list-item-action>
                        <v-list-item-title v-text="$t('Mentors')"></v-list-item-title>
                    </v-list-item>
                </template>
                <template v-else-if="type === 'crowdsource'">
                    <v-list-group no-action>
                        <template v-slot:activator>
                            <v-list-item-action>
                                <v-icon>mdi-account</v-icon>
                            </v-list-item-action>
                            <v-list-item-title v-text="fullName"></v-list-item-title>
                        </template>
                        <v-list-item :to="`/${$i18n.locale}/crowdsource/settings`">
                            <v-list-item-action>
                                <v-icon>mdi-cog</v-icon>
                            </v-list-item-action>
                            <v-list-item-title v-text="$t('Settings')"></v-list-item-title>
                        </v-list-item>
                    </v-list-group>
                </template>
                <v-list-group no-action>
                    <template v-slot:activator>
                        <v-list-item-action>
                            <v-icon>mdi-lightbulb</v-icon>
                        </v-list-item-action>
                        <v-list-item-title v-text="$t('ECreative')"></v-list-item-title>
                    </template>
                    <v-list-item :to="`/${$i18n.locale}/ecreative/open/projects`">
                        <v-list-item-action>
                            <v-icon>mdi-lightbulb-on</v-icon>
                        </v-list-item-action>
                        <v-list-item-title v-text="$t('OpenProjects')"></v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="`/${$i18n.locale}/ecreative/resources`">
                        <v-list-item-action>
                            <v-icon>mdi-lightbulb-off</v-icon>
                        </v-list-item-action>
                        <v-list-item-title v-text="$t('PastWinningProjects')"></v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="`/${$i18n.locale}/ecreative/my/bids`">
                        <v-list-item-action>
                            <v-icon>mdi-currency-usd-circle</v-icon>
                        </v-list-item-action>
                        <v-list-item-title v-text="$t('MyBids')"></v-list-item-title>
                    </v-list-item>
                </v-list-group>
                <v-list-item @click="logout">
                    <v-list-item-action>
                        <v-icon>mdi-logout</v-icon>
                    </v-list-item-action>
                    <v-list-item-title v-text="$t('LogOut')"></v-list-item-title>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <v-app-bar
            app
            clipped-right
            class="main-toolbar"
            color="primary"
            dark
        >
            <div class="container px-0">
                <div class="d-flex align-center">
                    <router-link to="/" class="app-bar-logo">
                        <img src="@/assets/images/claass-logo-white-without-betta.svg"/>
                    </router-link>
                    <v-spacer />
                    <div class="d-none d-md-flex">
                        <v-menu 
                            offset-y
                            transition="slide-y-transition"
                            bottom
                        >
                            <template v-slot:activator="{ on }">
                                <v-btn
                                    text
                                    class="mr-3"
                                    color="white"
                                    v-on="on"
                                    :title="$t('ECreative')"
                                    v-text="$t('ECreative')"
                                ></v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item :to="`/${$i18n.locale}/ecreative/open/projects`">
                                    <v-list-item-title v-text="$t('OpenProjects')"></v-list-item-title>
                                </v-list-item>
                                <v-list-item :to="`/${$i18n.locale}/ecreative/resources`">
                                    <v-list-item-title v-text="$t('PastWinningProjects')"></v-list-item-title>
                                </v-list-item>
                                <v-list-item :to="`/${$i18n.locale}/ecreative/my/bids`">
                                    <v-list-item-title v-text="$t('MyBids')"></v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                        <template v-if="type === 'tutor'">
                            <v-menu 
                                offset-y
                                transition="slide-y-transition"
                                bottom
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        text
                                        color="white"
                                        v-on="on"
                                    ><v-icon left>mdi-account</v-icon> {{ fullName }}</v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item :to="`/${$i18n.locale}/tutor/profile`">
                                        <v-list-item-title v-text="$t('Profile')"></v-list-item-title>
                                    </v-list-item>
                                    <template v-if="user.customerId && user.completedProfile && user.active">
                                        <v-list-item :to="`/${$i18n.locale}/tutor/resources`">
                                            <v-list-item-title v-text="$t('Resources')"></v-list-item-title>
                                        </v-list-item>
                                        <v-list-item :to="`/${$i18n.locale}/tutor/calendar`">
                                            <v-list-item-title v-text="$t('Calendar')"></v-list-item-title>
                                        </v-list-item>
                                        <v-list-item :to="`/${$i18n.locale}/tutor/sessions`">
                                            <v-list-item-title v-text="$t('Sessions')"></v-list-item-title>
                                        </v-list-item>
                                        <v-list-item :to="`/${$i18n.locale}/tutor/settings`">
                                            <v-list-item-title v-text="$t('Settings')"></v-list-item-title>
                                        </v-list-item>
                                    </template>
                                    <v-list-item :to="`/${$i18n.locale}/tutor/billing`">
                                        <v-list-item-title v-text="$t('Billing')"></v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="logout">
                                        <v-list-item-title v-text="$t('LogOut')"></v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                        <template v-else-if="type === 'student' || type === 'parent'">
                            <v-btn
                                class="mr-3"
                                color="white"
                                text
                                :to="`/${$i18n.locale}/student/askMentor`"
                                :title="$t('ASK A MENTOR')"
                                v-text="$t('ASK A MENTOR')"
                            ></v-btn>   
                            <v-btn
                                class="mr-3"
                                color="white"
                                text
                                :to="`/${$i18n.locale}/student/tutors`"
                                :title="$t('Mentors')"
                                v-text="$t('Mentors')"
                            ></v-btn>   
                            <v-menu 
                                offset-y
                                transition="slide-y-transition"
                                bottom
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        text
                                        color="white"
                                        v-on="on"
                                    ><v-icon left>mdi-account</v-icon> {{ fullName }}</v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item :to="`/${$i18n.locale}/student/profile`">
                                        <v-list-item-title v-text="$t('Profile')"></v-list-item-title>
                                    </v-list-item>
                                    <v-list-item :to="`/${$i18n.locale}/student/sessions`">
                                        <v-list-item-title v-text="$t('Sessions')"></v-list-item-title>
                                    </v-list-item>
                                    <v-list-item :to="`/${$i18n.locale}/student/settings`">
                                        <v-list-item-title v-text="$t('Settings')"></v-list-item-title>
                                    </v-list-item>
                                    <!-- <v-list-item :to="`/${$i18n.locale}/tutor/billing`">
                                        <v-list-item-title v-text="$t('Billing')"></v-list-item-title>
                                    </v-list-item> -->
                                    <v-list-item @click="logout">
                                        <v-list-item-title  v-text="$t('LogOut')"></v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                        <template v-else-if="type === 'crowdsource'">
                            <v-menu 
                                offset-y
                                transition="slide-y-transition"
                                bottom
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        text
                                        color="white"
                                        v-on="on"
                                    ><v-icon left>mdi-account</v-icon> {{ fullName }}</v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item :to="`/${$i18n.locale}/crowdsource/settings`">
                                        <v-list-item-title v-text="$t('Settings')"></v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="logout">
                                        <v-list-item-title  v-text="$t('LogOut')"></v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </div>
                    <v-app-bar-nav-icon @click.stop="drawer = !drawer" class="d-md-none" />
                </div>
            </div>
        </v-app-bar>
        <v-content>
            <v-layout>
                <router-view/>
            </v-layout>
        </v-content>
    </v-app>
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'memberLayout',
        data: () => ({
            drawer: false
        }),
        computed: {
            ...mapGetters(['fullName', 'type', 'user', 'languages'])
        },
        methods: {
            logout() {
                this.$store.dispatch('logout')
                this.$router.push(`/${this.$i18n.locale}/`)
            }
        }
    }
</script>

<style lang="scss" scoped>
.app-bar-logo{
    img{
        height: 40px;
    }
}
.main-toolbar{
    box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.1), 0px 6px 10px 0px rgba(0, 0, 0, 0.07), 0px 1px 18px 0px rgba(0, 0, 0, 0.06) !important;
}
.v-application--is-ltr .v-list-group--no-action > .v-list-group__items > .v-list-item{
    padding-left: 53px;
}
.v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child{
    margin-right: 15px;
}
</style>